import * as React from "react";
import { Control, useFieldArray, useWatch } from "react-hook-form";
import {
  Text,
  Grid,
  Title,
  Button,
  ActionIcon,
  Modal,
  Group,
  Divider,
  useMantineTheme,
  Stack,
  Flex,
} from "@mantine/core";

import {
  CCheckbox,
  CMultiSelect,
  CMultiSelectCreatable,
  CRadioGroup,
  CSelect,
  CTextarea,
  CTextInput,
} from "@supportinitiative/react-hook-form-mantine";

import { ReconsetCVMContext } from "./ReconsetCVM";

import { columnTypes } from "./ReconsetUtils";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import { getId } from "../utilities";
import DashboardCVM from "./DashboardCVM";

function DashboardsAndActionsCVM({
  name,
  control,
}: {
  name: `definition`;
  control: Control<any>;
}) {
  const { state: reconsetFormState, dispatch: reconsetFormDispatch } =
    React.useContext(ReconsetCVMContext);

  const theme = useMantineTheme();

  const dashboardsArray = useFieldArray({
    control,
    name: `${name}.dashboards`,
    keyName: "key",
  });

  const actionsArray = useFieldArray({
    control,
    name: `${name}.actions`,
    keyName: "key",
  });

  return (
    <Stack
      style={{
        marginTop: theme.spacing.xs,
        padding: theme.spacing.xs,
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Group mb="xs" align="center" style={{ alignItems: "center" }}>
          <Flex>
            <Title
              m={0}
              order={5}
              style={{
                padding: "0px 5px",
                backgroundColor: "#16A596",
                color: "#fff",
              }}
            >
              Dashboards
            </Title>
          </Flex>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              dashboardsArray.append({
                name: "",
                type: "TEXT",
                label: "",
                notNull: "NO",
                id: getId(),
              });
            }}
            style={{
              display:
                reconsetFormState.currentAction.toUpperCase() === "VIEW"
                  ? "none"
                  : "",
            }}
            disabled={reconsetFormState.actionOptions.disableAll}
          >
            <IconPlus />
          </ActionIcon>
        </Group>

        {dashboardsArray.fields.length === 0 ? (
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={8}>
              <Divider label="No Dashboards" labelPosition="left" />
            </Grid.Col>
          </Grid>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid align="stretch" gutter={"xs"} mb="xs">
              {dashboardsArray.fields.map((field, index) => {
                return (
                  <React.Fragment key={field.key}>
                    <Grid.Col span={2} key={field.key}>
                      <Flex align="end">
                        <DashboardCVM
                          name={`definition.dashboards.${index}`}
                          control={control}
                        />
                        {!reconsetFormState.actionOptions.disableAll && (
                          <ActionIcon
                            size="sm"
                            variant="white"
                            color="gray"
                            ml="xs"
                            onClick={() => {
                              dashboardsArray.remove(index);
                            }}
                            disabled={
                              reconsetFormState.actionOptions.disableAll
                            }
                          >
                            <IconTrash />
                          </ActionIcon>
                        )}
                      </Flex>
                    </Grid.Col>
                  </React.Fragment>
                );
              })}
            </Grid>
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Group mb="xs" align="center" style={{ alignItems: "center" }}>
          <Flex>
            <Title
              m={0}
              order={5}
              style={{
                padding: "0px 5px",
                backgroundColor: "#16A596",
                color: "#fff",
              }}
            >
              Actions
            </Title>
          </Flex>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              actionsArray.append({
                name: "",
                id: getId(),
              });
            }}
            style={{
              display:
                reconsetFormState.currentAction.toUpperCase() === "VIEW"
                  ? "none"
                  : "",
            }}
            disabled={reconsetFormState.actionOptions.disableAll}
          >
            <IconPlus />
          </ActionIcon>
        </Group>

        {actionsArray.fields.length === 0 ? (
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={8}>
              <Divider label="No Actions" labelPosition="left" />
            </Grid.Col>
          </Grid>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid align="stretch" gutter={"xs"} mb="xs">
              {actionsArray.fields.map((field, index) => {
                return (
                  <React.Fragment key={field.key}>
                    <Grid.Col span={2} key={field.key}>
                      <Flex align="end">
                        {/* <DashboardCVM
                          name={`definition.dashboards.${index}`}
                          control={control}
                        /> */}
                        {!reconsetFormState.actionOptions.disableAll && (
                          <ActionIcon
                            size="sm"
                            variant="white"
                            color="gray"
                            ml="xs"
                            onClick={() => {
                              actionsArray.remove(index);
                            }}
                            disabled={
                              reconsetFormState.actionOptions.disableAll
                            }
                          >
                            <IconTrash />
                          </ActionIcon>
                        )}
                      </Flex>
                    </Grid.Col>
                  </React.Fragment>
                );
              })}
            </Grid>
          </div>
        )}
      </div>
    </Stack>
  );
}

export default DashboardsAndActionsCVM;
